/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFlagIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-flag"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.9 14.8L6.9 20.32Q6.9 20.88 6.51 21.26Q6.13 21.65 5.58 21.65Q5.03 21.65 4.64 21.26Q4.25 20.88 4.25 20.32L4.25 4.67Q4.25 4.13 4.64 3.74Q5.03 3.35 5.58 3.35L13.43 3.35Q13.9 3.35 14.26 3.65Q14.63 3.95 14.72 4.4L14.95 5.4L19.43 5.4Q19.98 5.4 20.36 5.79Q20.75 6.17 20.75 6.72L20.75 15.53Q20.75 16.07 20.36 16.46Q19.98 16.85 19.43 16.85L13.6 16.85Q13.13 16.85 12.76 16.55Q12.4 16.25 12.3 15.78L12.1 14.8Z" fill={color} />
    </svg>
  );
}
